/*
 * tira-productos — barra fija móvil de snippets/tira-productos.liquid.
 *
 * La barra lleva a la tira por ancla (sin JS). Este script sólo decide
 * cuándo se ve: oculta mientras la tira está en pantalla, visible en
 * cuanto sale de ella. Sin IntersectionObserver la barra se queda
 * oculta (atributo `hidden` del HTML), que es el estado seguro.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function init() {
    document.querySelectorAll('[data-tira-sticky]').forEach(function (bar) {
      var tira = document.getElementById(bar.getAttribute('data-tira-sticky'));
      if (!tira) return;

      new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
      }).observe(tira);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
